/* Norvelka — scripts globales (vanilla JS, sin librerías externas) */

function initReveals() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

function initGalerias() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        var srcset = mini.getAttribute('data-full-srcset');
        var alt = mini.getAttribute('data-alt') || '';
        if (src) principal.setAttribute('src', src);
        if (srcset) principal.setAttribute('srcset', srcset);
        principal.setAttribute('alt', alt);
        miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
        mini.classList.add('mt-miniatura-activa');
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (wrap) {
    var dataEl = wrap.querySelector('[data-mt-variantes-json]');
    var idInput = wrap.querySelector('[data-mt-variant-id]');
    var precioEl = wrap.querySelector('[data-mt-precio]');
    var precioCompareEl = wrap.querySelector('[data-mt-precio-compare]');
    var botonComprar = wrap.querySelector('[data-mt-boton-comprar]');
    var selects = wrap.querySelectorAll('[data-mt-opcion]');
    if (!dataEl || !idInput || !selects.length) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioCompareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioCompareEl.textContent = moneda(variante.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible');
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado');
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function initOpcionesCompra() {
  document.querySelectorAll('[data-mt-opciones-compra]').forEach(function (wrap) {
    var opciones = wrap.querySelectorAll('[data-mt-opcion-compra]');
    var contenedor = wrap.closest('[data-mt-producto]');
    if (!contenedor || !opciones.length) return;
    var variantInput = contenedor.querySelector('[data-mt-variant-id]');
    var gelInput = contenedor.querySelector('[data-mt-gel-variant-id]');
    var precioActivo = contenedor.querySelector('[data-mt-precio-activo]');
    var precioCompare = contenedor.querySelector('[data-mt-precio-compare]');
    var variantesWrap = contenedor.querySelector('[data-mt-variantes-wrap]');
    var botonComprar = contenedor.querySelector('[data-mt-boton-comprar]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    }

    opciones.forEach(function (opcion) {
      opcion.addEventListener('click', function () {
        opciones.forEach(function (o) { o.classList.remove('mt-opcion-compra-activa'); });
        opcion.classList.add('mt-opcion-compra-activa');

        var variantId = opcion.getAttribute('data-variant-id');
        var gelVariantId = opcion.getAttribute('data-gel-variant-id');
        var precio = parseInt(opcion.getAttribute('data-precio'), 10);
        var precioCompareVal = parseInt(opcion.getAttribute('data-precio-compare'), 10);
        var mostrarVariantes = opcion.getAttribute('data-mostrar-variantes') === 'true';
        var nombreBoton = opcion.getAttribute('data-nombre-boton');

        if (variantInput) variantInput.value = variantId;
        if (gelInput) gelInput.value = gelVariantId || '';
        if (precioActivo) precioActivo.textContent = moneda(precio);
        if (precioCompare) {
          if (precioCompareVal && precioCompareVal > precio) {
            precioCompare.textContent = moneda(precioCompareVal);
            precioCompare.style.display = '';
          } else {
            precioCompare.style.display = 'none';
          }
        }
        if (variantesWrap) variantesWrap.style.display = mostrarVariantes ? '' : 'none';
        if (botonComprar) botonComprar.textContent = nombreBoton;
      });
    });

    var form = wrap.closest('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (botonComprar) { botonComprar.disabled = true; botonComprar.textContent = 'Adding...'; }

        var items = [{ id: variantInput.value, quantity: 1 }];
        if (gelInput && gelInput.value) items.push({ id: gelInput.value, quantity: 1 });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () {
            if (botonComprar) { botonComprar.disabled = false; botonComprar.textContent = 'Something went wrong — try again'; }
          });
      });
    }
  });
}

function initSelectorRitualHorizontal() {
  document.querySelectorAll('[data-mt-add-ritual]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var variantId = boton.getAttribute('data-variant-id');
      var gelVariantId = boton.getAttribute('data-gel-variant-id');
      if (!variantId) return;
      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = 'Adding...';

      var items = [{ id: variantId, quantity: 1 }];
      if (gelVariantId) items.push({ id: gelVariantId, quantity: 1 });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        });
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (Number.isInteger(fin) ? Math.round(valor) : valor.toFixed(1)).toString();
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toString();
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}

function initFaq() {
  document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
    var pregunta = item.querySelector('[data-mt-faq-pregunta]');
    var wrap = item.querySelector('.mt-faq-respuesta-wrap');
    if (!pregunta || !wrap) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      var grupo = item.closest('[data-mt-faq]');
      grupo.querySelectorAll('[data-mt-faq-item]').forEach(function (i) {
        i.classList.remove('mt-faq-abierto');
        i.querySelector('[data-mt-faq-pregunta]').setAttribute('aria-expanded', 'false');
        var w = i.querySelector('.mt-faq-respuesta-wrap');
        if (w) w.style.maxHeight = '';
      });
      if (!abierto) {
        item.classList.add('mt-faq-abierto');
        pregunta.setAttribute('aria-expanded', 'true');
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGalerias();
  initVariantes();
  initOpcionesCompra();
  initSelectorRitualHorizontal();
  initContadores();
  initFaq();
});
